import React from "react";
import CardServicos from "./cardServicos";

export default function ComoFazemos({ title = "", cards = [] }) {
    return (
        <div className="w-full bg-[#040116] py-20 relative overflow-hidden">
            {/* Background com grafismos */}
            <div className="absolute inset-0 opacity-10">
                <img
                    src="/assets/grafismos.svg"
                    alt="Grafismos"
                    className="w-full h-full object-cover"
                />
                <img
                    src="/assets/grafismos.svg"
                    alt="Grafismos"
                    className="absolute inset-0 w-full h-full object-cover rotate-180"
                />
            </div>

            <div className="max-w-[1200px] mx-auto relative z-10 px-4">
                {/* Título */}
                <h2 className="text-white text-3xl md:text-5xl text-center mb-16">
                    {typeof title === "string" ? (
                        <>
                            <span className="font-inter-light">
                                {title.split(" ")[0]}{" "}
                            </span>
                            <span className="font-inter-bold">
                                {title.split(" ").slice(1).join(" ")}
                            </span>
                        </>
                    ) : (
                        title
                    )}
                </h2>

                {/* Cards */}
                <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                    {cards.map((card, index) => (
                        <CardServicos
                            key={index}
                            icon={card.icon}
                            iconHover={card.iconHover}
                            title={card.title}
                            text={card.text}
                            glowColor={card.glowColor}
                            height={card.height}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
